import * as React from "react";
import * as ReactDOM from "react-dom";
import {ProgressRingControl} from "../../../Intercom.ReactUI/Views/ProgressRingControl";

export enum LogoutPanelStatus {
    InProgress, Success, Failure
}

export interface LogoutPanelProps extends React.Props<any> {
        title: string;
        status: LogoutPanelStatus;
    }

    export interface LogoutPanelState {
    }

    export class LogoutPanel extends React.Component<LogoutPanelProps, LogoutPanelState> {
        constructor(props) {
            super(props);

            this.state = {
                status: LogoutPanelStatus.InProgress
            };
    }

        public render(): JSX.Element {
            let stateCSSClass: string;
            switch (this.props.status) {
                case LogoutPanelStatus.InProgress:
                    stateCSSClass = "logout-progress";
                    break;
                case LogoutPanelStatus.Failure:
                    stateCSSClass = "logout-failure";
                    break;
                case LogoutPanelStatus.Success:
                    stateCSSClass = "logout-success";
                    break;
            }
            return (
                <div className={"logout-panel " + stateCSSClass}>
                    <div className="logout-progress-icon">
                    <ProgressRingControl/>
                    </div>
                    <div className="logout-success-icon"></div>
                    <div className="logout-failure-icon"></div>
                    <div className="logout-item-title">
                        {this.props.title}
                    </div>
                </div>
            );
        }
    }




// WEBPACK FOOTER //
// ./Client/Views/LogoutPanel.tsx